import { z } from "zod";
import { schemes } from "@zeal/common";

export const partnerBusinessDocumentItemSchema = z.object({
  key: z.string(),
  last_modified: z.string().optional(),
  size: z.number().optional(),
});

export type TPartnerBusinessDocumentItem = z.infer<
  typeof partnerBusinessDocumentItemSchema
>;

export const listPartnerBusinessDocumentsParamsSchema = z.object({
  whiteLabelID: schemes.uuid(),
});

export type TListPartnerBusinessDocumentsParams = z.infer<
  typeof listPartnerBusinessDocumentsParamsSchema
>;

export const listPartnerBusinessDocumentsResponseSchema = z.object({
  ein_letter: partnerBusinessDocumentItemSchema.optional(),
  additional_documents: z.array(partnerBusinessDocumentItemSchema).optional(),
});

export type TListPartnerBusinessDocumentsResponse = z.infer<
  typeof listPartnerBusinessDocumentsResponseSchema
>;
